import { PutObjectCommand } from '@aws-sdk/client-s3'
import { useAwsCredentials, useAwsS3Client } from 'Data/s3.js'
import { useMutation } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { dateISOToDateAndTimeShort } from 'Data/format.js'
import MUTATION from './mutation.graphql.js'
import { getNewDocumentTemplateTable } from '../../../helpers.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let location_id = useDataValue({
    context: 'tab',
    path: 'selected.document_templates.location_id',
    viewPath: props.viewPath,
  })
  let getAwsCredentials = useAwsCredentials(props)
  let getS3Client = useAwsS3Client(props)
  let [, executeMutation] = useMutation(MUTATION)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    console.log({ type: 'onSubmit', value })
    let awsCredentials = await getAwsCredentials()
    let s3 = await getS3Client()
    if (!s3 || !awsCredentials) return

    let [mammoth, pdfjs] = await Promise.all([
      import('mammoth'),
      import('pdfjs-dist'),
    ])

    pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`

    let result = await Promise.all(
      value.files.map(async item => {
        try {
          let content = null

          switch (item.extension) {
            case 'docx': {
              let html = await mammoth.convertToHtml({
                arrayBuffer: await item.data.arrayBuffer(),
              })
              content = html.value
              break
            }

            case 'pdf': {
              let arrayBuffer = await item.data.arrayBuffer()
              let pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise

              content = ''
              for (let i = 1; i <= pdf.numPages; i++) {
                let page = await pdf.getPage(i)
                let textContent = await page.getTextContent()

                let pageText = textContent.items
                  .map(item => item.str)
                  .join(' ')
                  .replace(/\s{2,}/g, ' ')
                  .trim()

                content += `<p>${pageText}</p>\n`
              }
              break
            }

            default: {
              break
            }
          }
          if (content === null) return null

          content = getNewDocumentTemplateTable(content)

          let file_key = crypto.randomUUID()

          await s3.send(
            new PutObjectCommand({
              // we are using vaxiom-files bucket to store the document templates
              Bucket: awsCredentials.legacy_storage_bucket_name,
              Key: `patientdoc/${file_key}`,
              Body: content,
              ContentType: 'text/html',
            })
          )

          let name = item.name
            .replace(`.${item.extension}`, '')
            .replace(/\(\d+\)/g, '')
            .trim()

          let mutationResponse = await executeMutation({
            name,
            organization_id: location_id,
            file_key,
            is_contract: /contract/i.test(name),
          })
          if (
            mutationResponse.error?.graphQLErrors.some(
              item =>
                item.extensions?.code === 'constraint-violation' &&
                /name already exists/.test(item.message)
            )
          ) {
            mutationResponse = await executeMutation({
              name: `${name} - ${dateISOToDateAndTimeShort(new Date())}`,
              organization_id: location_id,
              file_key,
              is_contract: /contract/i.test(name),
            })
          }

          return {
            mutationResponse,
            file_key,
            item,
          }
        } catch (error) {
          return { item, error }
        }
      })
    )

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
